import { Message } from "primereact/message"

export default function FormErrorMessage({ msg }) {
  return (
    <div className="card">
      <Message severity="error" text={`Error: ${msg}`} />
    </div>
  )
}
